import * as React from "react";
import { Button, StyleProp, TextInput, ViewStyle } from "react-native";
import RadioForm, {
  RadioButton,
  RadioButtonInput,
  RadioButtonLabel,
} from "react-native-simple-radio-button";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";

import useUpdateStudentProgress from "../../hooks/studentProgress/useUpdateStudentProgress";
import useFetchSyllabusStudentProgress from "../../hooks/syllabi/useFetchSyllabusStudentProgress";
import { Text, View } from "../../components/Themed";
import commonStyles from "../../styles/common";
import useAutosave from "../../common/hooks/useAutosave";
import {
  Syllabus,
  Move,
  StudentProgress,
  StudentProgressStatus,
} from "../../types";

//type StudentProgressValues = Pick<StudentProgress, "id"|"moveId"|"status"> ;
type StudentProgressValues = {
  id: StudentProgress["id"];
  moveStatus: StudentProgressStatus;
};

export interface StudentProgressProps {
  //studentProgress?: StudentProgress;
  id?: StudentProgress["id"];
  moveStatus?: StudentProgressStatus;
  moveId?: Move["id"];
  syllabusId?: Syllabus["id"];
  //style?: StyleProp<ViewStyle>;
  //onSave?: (values: StudentProgressValues) => await useUpdateStudentProgress( {id: values?.id, moveId: values?.moveId}
}

function StudentProgressForm({
  id,
  moveStatus,
  moveId,
  syllabusId,
}: StudentProgressProps) {
  const { control, handleSubmit } = useForm<StudentProgressValues>({
    defaultValues: { id, moveStatus: moveStatus },
  });
  const [editingVideos, setEditingVideos] = React.useState(false);
  const [editingFamily, setEditingFamily] = React.useState(false);
  const { mutate: updateStudentProgress } = useUpdateStudentProgress();
  const radio_props = [
    { label: "Not Started", value: StudentProgressStatus.NotStarted },
    { label: "In Progress", value: StudentProgressStatus.InProgress },
    { label: "Completed", value: StudentProgressStatus.Complete },
  ];

  const {
    data: studentProgress,
    isLoading,
    isError,
    error,
  } = useFetchSyllabusStudentProgress(syllabusId, moveId);

  var initialSelection: number;
  var count = 0;
  for (const prop of radio_props) {
    if (prop.value == studentProgress?.status) {
      initialSelection = count;
    }
    count = count++;
  }

  const save = (text?: StudentProgressStatus) =>
    useAutosave({
      onSave: handleSubmit(async (data) => {
        if (studentProgress) {
          await updateStudentProgress({
            id: studentProgress?.id,
            status: text,
          });
        }
      }),
    });

  return (
    <View style={{ flexDirection: "row", height: 100, padding: 20 }}>
      <Controller
        control={control}
        name="moveStatus"
        // rules={{
        //   required: true,
        // }}
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            <Text>Move Status</Text>

            {/* <TextInput
              style={commonStyles.textInput}
              onBlur={onBlur}
              value={value}
              onChangeText={text => {
                onChange(save(text));
              }} 
            /> */}
            <RadioForm
              radio_props={radio_props}
              initial={initialSelection}
              onPress={(value) => {
                onChange(save(value));
              }}
            />
          </>
        )}
      />
    </View>
  );
}

export default StudentProgressForm;
